export default "__VITE_ASSET__B8NlsC$Q__"